//Initialize Accordion
if (document.querySelector(".accordion-container")) {
	new Accordion(".accordion-container");
}

//Carousel Script
if (document.querySelector(".glide__slides")) {
	var allSlides = document.querySelectorAll(".glide");
	var allSlidesArray = Array.prototype.slice.call(allSlides);
	allSlidesArray.forEach((slide) => {
		const glide = new Glide(slide, {
			type: "slider",
			perView: 3,
			perTouch: 1,
			focusAt: "center",
			autoplay: false,
			accessibility: true,
			startAt: 2,
			rewind: false,
			classes: {
				disabledArrow: "glide__arrow--disabled",
			},
			peek: {
				before: 100,
				after: 50,
			},
			perSwipe: "|",
			breakpoints: {
				800: {
					perView: 1,
					startAt: 1,
					peek: 0,
				},
			},
		}).mount();
	});
}

//Check if Header Button link is external
const btns = document.querySelectorAll(".wp-block-button__link");
const allBtns = Array.prototype.slice.call(btns);
const currentHost = window.location.hostname;

let externalText = document.createElement("span");
externalText.append(document.createTextNode("link will open external site"));
externalText.classList.add("screen-reader-text");

if (btns) {
	allBtns.forEach((btn) => {
		if (btn.hasAttribute("href")) {
			let ctaLink = btn.getAttribute("href").split("/");

			if (ctaLink[2] !== currentHost) {
				btn.classList.add("external-link");
				btn.append(externalText);
			}
		}
	});
}
if (document.querySelector(".cta-btn")) {
	let currentHost = window.location.hostname;
	let ctaBtn = document.querySelector(".cta-btn");
	let ctaLink = ctaBtn.getAttribute("href").split("/");

	if (ctaLink[0] !== currentHost) {
		ctaBtn.classList.add("external-link");
		ctaBtn.append(externalText);
	}
}


////Pagination
if (document.querySelector(".navigation-pagination")) {
	let paginationList = document.querySelectorAll(".navigation-pagination ul li");

	if (paginationList[0].classList.contains("active")) {
		paginationList[0].style.position = "relative";
	}

	if (paginationList[paginationList.length - 1].classList.contains("active")) {
		paginationList[paginationList.length - 1].style.position = "relative";
	}
}

////Masonary
if (document.querySelector(".allcontainer")) {
	var elem = document.querySelector(".allcontainer");
	var msnry = new Masonry(elem, {
		// options
		itemSelector: ".item",
		columnWidth: ".grid-sizer",
		gutter: 15,
	});

	//Filters
	// const filterBtn = document.querySelectorAll('.filters button');
	// var allfilterBtn = Array.prototype.slice.call(filterBtn);
	//let allblocks = document.querySelectorAll('.item');
	let allblocks = Array.prototype.slice.call(document.querySelectorAll(".item"));
	let selectedValue;
	let selectedOption;
	let availableItems;
	let buttons = document.querySelectorAll(".filters button"); //returns a nodelist

	for (let i = 0; i < buttons.length; i++) {
		buttons[i].addEventListener("click", onClickChange);
	}

	//Click Filter
	function onClickChange() {
		selectedValue = this.value;
		// if(selectedValue !== 'all'){
		//   allblocks = document.querySelectorAll('.item.block');
		// }
		allblocks.forEach(function (block) {
			block.classList.remove("block");

			if (selectedValue == "all") {
				block.classList.add("block");
			}

			if (block.getAttribute("data-cat") == selectedValue) {
				block.classList.add("block");
			}
		});
		msnry.layout();

		availableItems = Array.prototype.slice.call(document.querySelectorAll(".item.block"));
		document.getElementById("select").addEventListener("change", onSelectChange);
	}

	availableItems = Array.prototype.slice.call(document.querySelectorAll(".item.block"));

	document.getElementById("select").addEventListener("change", onSelectChange);

	function onSelectChange() {
		selectedOption = this.value;

		availableItems.forEach(function (item) {
			item.classList.remove("block");

			if (selectedOption == "all") {
				item.classList.add("block");
			}

			if (item.getAttribute("data-tag") == selectedOption) {
				item.classList.add("block");
			}
		});

		//Filter Click
		for (let i = 0; i < buttons.length; i++) {
			buttons[i].addEventListener("click", onClickChange);
		}

		msnry.layout();
	}

	/////Script_AJAX
	/* Ajax functions */
	$(document).ready(function () {
		//onclick
		$("#loadMore").on("click", function (e) {
			e.preventDefault();
			//init
			var that = $(this);
			var page = $(this).data("page");
			var newPage = page + 1;
			var ajaxurl = that.data("url");
			//ajax call
			$.ajax({
				url: ajaxurl,
				type: "post",
				data: {
					page: page,
					action: "ajax_script_load_more",
				},
				error: function (response) {
					console.log(response);
				},
				success: function (response) {
					//check
					if (response == 0) {
						$(".allcontainer").append('<div class="text-center no-more-post"><h4>You reached the end of the line!</h4><p>No more posts to load.</p></div>');
						$("#loadMore").hide();
					} else {
						that.data("page", newPage);
						$("#ajax-primary").append(response);

						msnry = new Masonry(elem, {
							// options
							itemSelector: ".item",
							columnWidth: ".grid-sizer",
							gutter: 15,
						});

						msnry.layout();
					}
				},
			});
		});
	});
}

//Breadcrumb Spacing
if (document.querySelector(".breadcrumb-container")) {
	document.querySelector(".content-area").style.marginTop = 0;
}

//Button Custom Colors Hover
var customBtn = $(".wp-block-button a.has-text-color.has-background");

customBtn.each(function (index) {
	var btnbgColor = $(this).css("backgroundColor");
	var btnColor = $(this).css("color");

	$(this)
		.mouseenter(function () {
			$(this).css({
				"background-color": btnColor,
				color: btnbgColor,
				"border-color": btnColor
			});
		})
		.mouseleave(function () {
			$(this).css({
				"background-color": btnbgColor,
				color: btnColor,
				"border-color": btnbgColor
			});
		});
});







//sidemenu mouse trap
if (window.addEventListener) {  // all browsers except IE before version 9
	window.addEventListener ("resize", sidemenufocustraponmobile, true);
	} else {
	if (window.attachEvent) {   // IE before version 9
		window.attachEvent("onresize", sidemenufocustraponmobile);
	}
	}

function sidemenufocustraponmobile(){
	let windowwidth = document.getElementsByTagName("BODY")[0].offsetWidth;
	if(windowwidth < 960){
		sidemenuaccessibility();
	}
}
window.addEventListener('DOMContentLoaded', (event) => {sidemenufocustraponmobile()});
function sidemenuaccessibility(){
var sidemenu = document.querySelector(".sidebar-assesment-menu .side-menu");
if(sidemenu){
const  focusableElementssubmenu = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
const firstFocusableElementsubmenu = sidemenu.querySelectorAll(focusableElementssubmenu)[0]; // get first element to be focused inside modal
const focusableContentsubmenu = sidemenu.querySelectorAll(focusableElementssubmenu);

const lastFocusableElementsubmenu = focusableContentsubmenu[focusableContentsubmenu.length - 1]; // get last element to be focused inside modal

// submenu buttons
let closemobilesidemenu = document.querySelector(".close-mobile-side-menu");
let openmobilesidemenu = document.querySelector(".open-mobile-side-menu");
if(closemobilesidemenu){
	closemobilesidemenu.addEventListener("click",function(e){
		e.preventDefault();
		openmobilesidemenu.focus();
		console.log("close clicked");
		document.querySelector('.sidebar-assesment-menu .side-menu').style.display = 'none';
		document.querySelector('.sidebar-assesment-menu .mobile-only').style.display = 'block';
	});
}

if(openmobilesidemenu){
	openmobilesidemenu.addEventListener("click",function(e){
		e.preventDefault();
		closemobilesidemenu.focus();
		console.log("open clicked");
		document.querySelector('.sidebar-assesment-menu .mobile-only').style.display = 'none';
		document.querySelector('.sidebar-assesment-menu .side-menu').style.display = 'block';
	});
}


document.addEventListener('keydown', function(e) {
	
  let isTabPressed = e.key === 'Tab' || e.keyCode === 9;
  let isEnterPressed =  e.keyCode === 13;
//   if(isEnterPressed){
//     if (document.activeElement === firstFocusableElementsubmenu) {
//       sidemenu.style.display = "none";
//       e.preventDefault();
//     }
//   }

  if (!isTabPressed) {
    return;
  }

  if (e.shiftKey) { // if shift key pressed for shift + tab combination
    if (document.activeElement === firstFocusableElementsubmenu) {
      lastFocusableElementsubmenu.focus(); // add focus for the last focusable element
      e.preventDefault();
	  
    }
  } else { // if tab key is pressed
    if (document.activeElement === lastFocusableElementsubmenu) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
      firstFocusableElementsubmenu.focus(); // add focus for the first focusable element
      e.preventDefault();
	  
    }
  }
});
}
}


// side menu adding active class on li

window.addEventListener('DOMContentLoaded', (event) => {sidemenufocustaddclass()});
function sidemenufocustaddclass(){
	
	let submenua = document.querySelectorAll(".side-menu .subnav .page_item a");
	for(let i = 0;  i < submenua.length; i++){
		submenua[i].addEventListener("focus", function(e){
			console.log(e);
			e.target.parentElement.classList.add('focused');
		});
		submenua[i].addEventListener("focusout", function(e){
			console.log(e);
			e.target.parentElement.classList.remove('focused');
		});
	}
}